import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import { Aplicacao } from 'src/app/_models/usuario/aplicacao';
import { AplicacaoService } from 'src/app/_services/aplicacao.service';
import { Empresa } from 'src/app/_models/usuario/empresa';
import { EmpresaService } from 'src/app/_services/empresa.service';
import { AplicacaoResponse } from 'src/app/_models/response/aplicacaoResponse';
import { Usuario } from 'src/app/_models/usuario/usuario';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { Perfil } from 'src/app/_models/usuario/perfil';
import {PickListModule} from 'primeng/picklist';
import { BscobrancaTranslate } from 'src/app/_services/bscobrancatranslate';


@Component({
    templateUrl: 'aplicacao.component.html',
    styleUrls: ['../../../demo/view/tabledemo.scss'],
    styles: [`
        :host ::ng-deep .p-dialog .product-image {
            width: 150px;
            margin: 0 auto 2rem auto;
            display: block;
        }

        @media screen and (max-width: 960px) {
            :host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-tbody > tr > td:last-child {
                text-align: center;
            }

            :host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-tbody > tr > td:nth-child(6) {
                display: flex;
            }
        }

    `],
    providers: [MessageService, ConfirmationService]
})

export class AplicacaoComponent implements OnInit {

    aplicacaoDialog: boolean;
    aplicacoes: Aplicacao[];
    aplicacao: Aplicacao;
    selectedAplicacoes: Aplicacao[];
    submitted: boolean;
    cols: any[];

    empresas: Empresa[] = [];
    empresa: Empresa;
    statusExibed: boolean;
    usuario: Usuario;
    perfil: Perfil;

    empresaSource: Empresa[];
    empresaTarget: Empresa[];
    blocked: boolean;

   total: number;
   manterAplicacaoLabel: string;
   labelHeader: string;
   header: any[];

    constructor(private aplicacaoService: AplicacaoService, private messageService: MessageService,
                private confirmationService: ConfirmationService, private breadcrumbService: AppBreadcrumbService,
                private empresaService: EmpresaService, private authenticationService: AuthenticationService,
                private bscobrancaTranslate: BscobrancaTranslate) {
        this.manterAplicacaoLabel = this.bscobrancaTranslate.getText('menu.manterAplicacao');
        this.labelHeader = this.bscobrancaTranslate.getText('menu.administracao');
        this.breadcrumbService.setItems([
            { label: this.labelHeader },
            { label: this.manterAplicacaoLabel, routerLink: ['/administracao/aplicacao/aplicacao'] }
        ]);
    }

    ngOnInit(): void {
        this.usuario = this.authenticationService.atualUserValue;
        this.perfil = this.authenticationService.atualUserPerfilValue;
        this.blocked = this.usuario.permiteAcao;

        this.header = ['Descricao Aplicacao', 'Nome Aplicacao'];

        this.aplicacaoService.getAplicaoPorEmpresa(this.usuario.empresa).toPromise().then(data => this.aplicacoes = data);
        this.empresaService.getEmpresasPorUsuario(this.usuario).toPromise().then(data => this.empresas = data);
        this.cols = [
            { field: 'codAplicacao', header: 'Codigo Aplicacao' },
            { field: 'dscAplicacao', header: 'Descricao Aplicacao' },
            { field: 'nmeAplicacao', header: 'Nome Aplicacao' },
            { field: 'dtaInclusao', header: 'Data Criacao' },
            { field: 'staAplicao', header: 'Situacao' }
        ];
        if (this.aplicacoes) {
            this.total = this.aplicacoes.length;
        } else {
            this.total = 0;
        }
    }

    openNew() {
        this.aplicacao = {};
        this.submitted = false;
        this.aplicacaoDialog = true;
        this.statusExibed = false;
        this.empresa = {};
        this.empresaService.getEmpresasPorUsuario(this.usuario).toPromise().then(data => this.empresaSource = data);
        this.empresaTarget = [];
    }

    deleteSelectedAplicacoes() {
        this.confirmationService.confirm({
            message: 'Are you sure you want to delete the selected products?',
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.aplicacoes = this.aplicacoes.filter(val => !this.selectedAplicacoes.includes(val));
                this.selectedAplicacoes = null;
                this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Aplicac\u00E7\u00E3o Exclu\u00EDda',
                life: 3000 });
            }
        });
    }

    editAplicacao(aplicacao: Aplicacao) {
        this.aplicacao = { ...aplicacao };
        this.empresaTarget = aplicacao.empresas;
        this.aplicacaoDialog = true;
        this.statusExibed = true;

        // tslint:disable-next-line: prefer-for-of
        for (let x = 0; x < aplicacao.empresas.length; x++) {
            this.empresas = this.empresas.filter(val => val.codEmpresa !== aplicacao.empresas[x].codEmpresa);
        }
        this.blocked = true;
        this.empresaSource = this.empresas;
    }

    viewAplicacao(aplicacao: Aplicacao) {
        this.aplicacao = { ...aplicacao };
        this.empresaTarget = aplicacao.empresas;
        this.aplicacaoDialog = true;
        this.statusExibed = false;
        this.blocked = false;
        // tslint:disable-next-line: prefer-for-of
        for (let x = 0; x < aplicacao.empresas.length; x++) {
            this.empresas = this.empresas.filter(val => val.codEmpresa !== aplicacao.empresas[x].codEmpresa);
        }
        this.empresaSource = this.empresas;
    }

    deleteAplicacao(aplicacao: Aplicacao) {
        this.confirmationService.confirm({
            message: this.bscobrancaTranslate.getText('mensagens.aplicacao-001') + aplicacao.nmeAplicacao + '?',
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.aplicacaoService.deletar(aplicacao).subscribe(
                    (aplicacaoResponse: AplicacaoResponse) => {
                        if (aplicacaoResponse) {
                            if (aplicacaoResponse.codigo === 0) {
                                this.aplicacoes = this.aplicacoes.filter(
                                    val => val.codAplicacao !== aplicacaoResponse.aplicacao.codAplicacao);
                                this.aplicacao = {};
                                this.messageService.add({ severity: 'success', summary: 'Successful',
                                            detail: this.bscobrancaTranslate.getText('mensagens.aplicacao-002'),
                                life: 3000 });
                                this.aplicacaoService.getAplicaoPorEmpresa(this.usuario.empresa).toPromise()
                                .then(data => this.aplicacoes = data);
                            } else {
                                this.messageService.add({ severity: 'error', summary: 'Error', detail: aplicacaoResponse.mensagem,
                                life: 3000 });
                            }
                        } else {
                            this.messageService.add({
                                severity: 'error', summary: 'Error', detail: this.bscobrancaTranslate.getText('mensagens.aplicacao-003'),
                                life: 3000
                            });
                        }
                    });
            }
        });
    }

    validateAplicacao() {
        if (!this.empresaTarget) {
            return this.bscobrancaTranslate.getText('mensagens.aplicacao-004');
        }
        if (!this.aplicacao.nmeAplicacao) {
            return this.bscobrancaTranslate.getText('mensagens.aplicacao-005');
        }
        if (!this.aplicacao.dscAplicacao) {
            return this.bscobrancaTranslate.getText('mensagens.aplicacao-006');
        }
        return '';
    }

    saveAplicacao() {
        this.submitted = true;
        const error = this.validateAplicacao();
        if (error !== '') {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error, life: 3000 });
        } else {
            if (this.aplicacao.nmeAplicacao.trim()) {
                if (this.aplicacao.codAplicacao != null) {
                    console.log(this.aplicacao);
                    this.aplicacao.empresas = this.empresaTarget;
                    this.aplicacaoService.atualizar(this.aplicacao).subscribe(
                        (aplicacaoResponse: AplicacaoResponse) => {
                            if (aplicacaoResponse) {
                                if (aplicacaoResponse.codigo === 0) {
                                    this.aplicacoes[
                                        this.findIndexById(aplicacaoResponse.aplicacao.codAplicacao)] = aplicacaoResponse.aplicacao;
                                    this.messageService.add({
                                        severity: 'success', summary: 'Successful', detail: this.bscobrancaTranslate.getText('mensagens.aplicacao-007'),
                                        life: 3000
                                    });
                                    this.aplicacaoService.getAplicaoPorEmpresa(this.usuario.empresa).toPromise()
                                    .then(data => this.aplicacoes = data);
                                } else {
                                    this.messageService.add({ severity: 'error', summary: 'Error', detail: aplicacaoResponse.mensagem,
                                    life: 3000 });
                                }
                            } else {
                                this.messageService.add({
                                    severity: 'error', summary: 'Error',
                                        detail: this.bscobrancaTranslate.getText('mensagens.aplicacao-008'), life: 3000});
                            }
                        });
                }
                else {
                    this.aplicacao.empresas = this.empresaTarget;
                    this.aplicacaoService.inserir(this.aplicacao).subscribe(
                        (aplicacaoResponse: AplicacaoResponse) => {
                            if (aplicacaoResponse) {
                                if (aplicacaoResponse.codigo === 0) {
                                    this.aplicacoes.push(aplicacaoResponse.aplicacao);
                                    this.messageService.add({
                                        severity: 'success', summary: 'Successful', detail: this.bscobrancaTranslate.getText('mensagens.aplicacao-009'),
                                        life: 3000
                                    });
                                    this.aplicacaoService.getAplicaoPorEmpresa(this.usuario.empresa).toPromise()
                                    .then(data => this.aplicacoes = data);
                                } else {
                                    this.messageService.add({ severity: 'error', summary: 'Error', detail: aplicacaoResponse.mensagem,
                                    life: 3000 });
                                }
                            } else {
                                this.messageService.add({
                                    severity: 'error', summary: 'Error',
                                    detail: this.bscobrancaTranslate.getText('mensagens.aplicacao-010'), life: 3000});
                            }
                        });

                }

                this.aplicacoes = [...this.aplicacoes];
                this.aplicacaoDialog = false;
                this.aplicacao = {};
            }
        }

    }

    hideDialog() {
        this.aplicacaoDialog = false;
        this.submitted = false;
    }

    findIndexById(id: number): number {
        let index = -1;
        for (let i = 0; i < this.aplicacoes.length; i++) {
            if (this.aplicacoes[i].codAplicacao === id) {
                index = i;
                break;
            }
        }
        return index;
    }


    downloadFile(filename= 'aplicacao') {
        const csvData = this.ConvertToCSV(this.header);
        console.log(csvData);
        const blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
        const dwldLink = document.createElement('a');
        const url = URL.createObjectURL(blob);
        const isSafariBrowser = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
        if (isSafariBrowser) {  // if Safari open in new window to save file with random filename.
            dwldLink.setAttribute('target', '_blank');
        }
        dwldLink.setAttribute('href', url);
        dwldLink.setAttribute('download', filename + '.csv');
        dwldLink.style.visibility = 'hidden';
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);
    }

    ConvertToCSV(headerList: any[]) {
         let str = '';
         let row = 'No;';
         // tslint:disable-next-line: forin
         for (const index in headerList) {
             row += headerList[index] + ';';
         }
         row = row.slice(0, -1);
         str += row + '\r\n';
         for (let i = 0; i < this.aplicacoes.length; i++) {
             const apl = this.aplicacoes[i];
             let line = (i + 1) + ';';
             line += apl.dscAplicacao + ';';
             line += apl.nmeAplicacao + ';';
             str += line + '\r\n';
         }
         return str;
     }

}
